import React from 'react'
import Makingunique from '../MyComponent/Makingunique';
import Seo from '../MyComponent/Seo';
import { EditorialIntro, EditorialSections } from '../MyComponent/EditorialContent';
import { aboutContent } from '../content/siteContent';

function AboutUs() {
    const background = {
        backgroundImage: `url(${require('../images/maxresdefault.jpg')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '460px',
        width: '100%',
        color: '#fff',
    };
    return (
        <main className="about-page">
            <Seo {...aboutContent} />
            <section className='Ready-made-Words about-photo-hero' style={background} aria-label="Craig Photo Letters studio">
                <div className="about-photo-caption">Letters are everywhere when you know how to look.</div>
            </section>
            <EditorialIntro heading={aboutContent.heading} intro={aboutContent.intro} eyebrow="Our story" />
            <EditorialSections sections={aboutContent.sections} ariaLabel="About our photographic alphabet" />
            <Makingunique />
        </main>
    )
}

export default AboutUs
